/**
 * Grenzen und Umrechnung des freien Zeitraumkalenders.
 *
 * Der Server nimmt Zeitraeume ab heute (Objektzeit) an. Laenger als 500 Tage scheitert bereits
 * die Ownership-Pruefung vor dem Senden — und weiter reicht der Channex-Horizont ohnehin nicht.
 * Der Kalender bietet deshalb nur an, was danach auch durchgeht.
 */
import { addIsoDays, diffIsoDays } from './calendarDates';

export const HORIZON_DAYS = 500;

export interface IsoRange {
  from: string;
  to: string;
}

/** Letzter waehlbarer Tag — der Horizont ist inklusiv. */
export function lastSelectableDay(today: string): string {
  return addIsoDays(today, HORIZON_DAYS - 1);
}

export function nightsInRange(range: IsoRange): number {
  return diffIsoDays(range.from, range.to) + 1;
}

/** Lokales Kalenderdatum ohne Zeitzonenverschiebung — der Picker arbeitet mit lokalen Tagen. */
export function toLocalDate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year!, (month ?? 1) - 1, day ?? 1);
}

export function toIsoDay(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function isSelectableRange(range: Partial<IsoRange>, today: string): range is IsoRange {
  if (!range.from || !range.to || range.to < range.from) return false;
  return range.from >= today && range.to <= lastSelectableDay(today);
}
